import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { HL7 } from '../../constant';

export interface SaveDraftFromProvider {
  id: string;
  name?: string;
  idType?: string;
  prefix?: string;
}

export interface SaveDraftToProvider {
  id: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  idType?: string;
  prefix?: string;
}

export interface SaveDraftDistributionPayload {
  reportId: string;
  fromProvider: SaveDraftFromProvider;
  toProvider: SaveDraftToProvider;
  /** Display segment format sent in the HL7 OBX: 'pdf' (default), 'txt', or 'rtf' */
  format?: 'pdf' | 'txt' | 'rtf';
  /** When set, update this existing DRAFT instead of creating a new one. */
  distributionId?: string;
}

export const saveDraftDistributionApi = createAsyncThunk(
  'hl7/saveDraftDistribution',
  async (payload: SaveDraftDistributionPayload, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) {
        return rejectWithValue('No token found');
      }
      const response = await fetch(HL7.SAVE_DRAFT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (!response.ok) {
        return rejectWithValue(result.msg || `Save draft failed: ${response.status}`);
      }
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
